import { Outlet } from 'react-router-dom';
import SidenavNew from 'components/Sidenav/SidenavNew'
import Topbar from 'components/Topbar/Topbar'


const SidebarLayout = () => (
  <>
    <SidenavNew />
    <div className="main-content">
      <Topbar />
      <Outlet />
    </div>
  </>
);

export default SidebarLayout;